import classNames from 'classnames';
import { Suspense, memo, useLayoutEffect } from 'react';
import lazyWithPreload from '@vindr/utils/LazyWithPreload';
import './LoadingIndicatorProgress.css';
import { GpacsLogoLight } from '../Logo';

const LOGO = {
  vindr: lazyWithPreload(() => import('@vindr/icons/src/icons/VindrOutlined')),
  vinmec: lazyWithPreload(
    () => import('@vindr/icons/src/icons/VinmecOutlined')
  ),
  gpacs: GpacsLogoLight,
};

/**
 *  A React component that renders a loading indicator.
 * if progress is not provided, it will render an infinite loading indicator
 * if progress is provided, it will render a progress bar
 * Optionally a textBlock can be provided to display a message
 */

interface LoadingIndicatorProgressProps {
  className?: string;
  textBlock?: JSX.Element;
  progress?: number;
  showLogo?: boolean;
  position?: 'absolute' | 'fixed' | 'relative' | 'static' | 'sticky';
}

const LogoComponent = memo(() => {
  const agency = window.AGENCY || 'vindr';
  const AgencyLogo = LOGO[agency];

  useLayoutEffect(() => {
    LOGO[agency]?.preload?.();
  }, [agency]);

  return (
    <Suspense fallback={null}>
      <AgencyLogo className="heart text-9xl" />
    </Suspense>
  );
});

function LoadingIndicatorProgress({
  className,
  textBlock,
  progress,
  showLogo = true,
  position = 'absolute',
}: LoadingIndicatorProgressProps): JSX.Element {
  return (
    <div
      className={classNames(
        `${position} top-0 left-0 z-50 flex flex-col items-center justify-center space-y-5`,
        className
      )}
    >
      {showLogo && <LogoComponent />}
      <div className="loading">
        {progress == null ? (
          // <div className="infinite-loading-bar bg-primary-light" />
          <div className="gooey">
            <span className="dot"></span>
            <div className="dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        ) : (
          <div
            className="bg-primary-light"
            style={{
              width: `${progress}%`,
              height: '8px',
            }}
          />
        )}
      </div>
      {textBlock}
    </div>
  );
}

export default LoadingIndicatorProgress;
